import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query"
import { getStudentLates } from "./api"

export const studentLatesQueryOptions = (studentNo: string) =>
    queryOptions({
        queryKey: ['studentLates', studentNo],
        queryFn: () => getStudentLates(studentNo),
    })

export function useStudentLates(studentNo: string) {
    return useQuery(studentLatesQueryOptions(studentNo))
}

export function useStudentLatesSuspense(studentNo: string) {
    return useSuspenseQuery(studentLatesQueryOptions(studentNo))
}
